// https://date-fns.org/docs/parse
import parseISO from 'date-fns/parseISO'
// https://date-fns.org/docs/format
import format from 'date-fns/format'

import store from '@store'
import { enUS, zhTW } from 'date-fns/locale'

const localeMap = {
  'zh-Hant': zhTW,
  en: enUS,
};

export default function formatDate(date, pattern = 'date') {
  if(!date) {
    return;
  }
  if(typeof date === 'string') {
    date = parseISO(date);
  }

  const patterMap = {
    date: 'yyyy-MM-dd', // '2019-06-13'
    dateTime: 'yyyy-MM-dd HH:mm', // 2019-01-01 00:00
    dateTimeSecond: 'yyyy-MM-dd HH:mm:ss', // 2019-01-01 00:00:00
    dateWeekDay: 'yyyy/MM/dd EEE', // '2019/06/13 週三'
    dateTimeWeekDay: 'yyyy/MM/dd EEE HH:mm', // '2019/6/13 週三 00:00'
    time: 'HH:mm', // '13:30',
    day: 'd', // '6',
  };
  const formatPattern = patterMap[pattern] || pattern;

  return format(date, formatPattern, {
    locale: localeMap[store.state.set.cachedLanguage],
  })
}

export function formatMinuteToHour(minute) {
  const foramtHour = minute / 60;

  return minute % 60 === 0
    ? `${foramtHour}小時`
    : `${foramtHour.toFixed(1)}小時`
}

export function formatMinuteToHourMinute(minute) {
  const foramtHour = Math.floor(minute / 60);
  const foramtMinute = minute % 60;

  const foramtHourText = foramtHour === 0
    ? ''
    : `${foramtHour}小時`;

  const foramtMinuteText = foramtMinute === 0
    ? ''
    : `${foramtMinute}分鐘`;

  return `${foramtHourText}${foramtMinuteText}`
}
